import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apriComeLaStruttura } from "../../../../components/Util/vistaStruttura";
import { Button, Modal, Row, Col, Spinner } from "react-bootstrap";
import TabellaLista from '../../../../components/Tabella/TabellaLista';
import { ChipFilter, filtroMultiplo } from '../../../../components/Tabella/ChipFilter';
import MyApiClient from '../../../../../api-client/MyApiClient';
import { nomiSport } from "../../../../components/Util/sportProdotto";
import { AvvisoNonInApp } from "../../../../components/Util/AvvisoInLista";
import DEFAULT_STRUTTURA from "../../../../../images/DEFAULT_STRUTTURA.png";
import { STATO_ARCHIVIATO, SelettoreArchivio, nellaVista, useVistaArchivio } from '../../../../components/Util/archivioProdotti';

// Valori dei filtri a bottoni: '' vuol dire "tutti".
const STATO_OPTIONS = ['Attivo', 'Non attivo', 'Bozza'];

export const AdminLessonsTable = () => {
	const navigate = useNavigate();

	const [data_json, setDataJson] = useState(null);
	const [statoFilter, setStatoFilter] = useState(STATO_OPTIONS);
	// Registro / Archivio (TASK #7)
	const [vista, setVista] = useVistaArchivio();

	const filteredData = useMemo(
		() =>
			data_json &&
			data_json.filter(
				(row) => filtroMultiplo(statoFilter, STATO_OPTIONS, row.status_label?.label) && nellaVista(vista, row),
			),
		[data_json, statoFilter, vista],
	);
	const [loadingShowed, setLoadingShowed] = useState(false);
	const [modalShowed, setModalShowed] = useState(false);
	const [modalTitle, setModalTitle] = useState('');
	const [modalText, setModalText] = useState('');
	
	const data_column = [
		{
			Header: 'Struttura',
			accessor: 'clubName',
			Cell: ({ row }) => {
				return (
					<div style={{ display: 'flex', alignItems: 'center' }}>
						<img
							src={row.original.imageUrlClub ? row.original.imageUrlClub : DEFAULT_STRUTTURA}
							alt={row.original.clubName}
							style={{
								width: '40px',
								height: '40px',
								borderRadius: '50%',
								marginRight: '10px'
							}}
						/>
						<div>
							{row.original.clubName}
						</div>
					</div>
				)
			}
		},
		{
			Header: 'Nome',
			Footer: 'Nome',
			accessor: 'name',
			// «Non pubblicata in app» (TASK #9): triangolino accanto al nome
			Cell: ({ row }) => <>{row.original.name}<AvvisoNonInApp prodotto={row.original} /></>,
		},
		{
			Header: 'Sport',
			Footer: 'Sport',
			accessor: 'sportType',
		},
		{
			Header: 'Prezzo base',
			Footer: 'Prezzo base',
			accessor: 'standard_price',
			disableGlobalFilter: true,
		},
		{
			Header: 'N. Acquisti',
			Footer: 'N. Acquisti',
			accessor: 'purchasesCount',
			disableGlobalFilter: true,
			Cell: ({ value }) => {
				return value || 0;
			},
			disableFilters: true,
		},
		{
			Header: 'Stato',
			Footer: 'Stato',
			accessor: 'status_label',
			disableGlobalFilter: true,
			Cell: ({ value }) => {
				return (
					<div className="d-flex align-items-center">
						<i className={`fa fa-circle me-1 ${value?value.class:''}`}></i>
						{value?value.label:''}
					</div>
				)
			},
			disableFilters: true,
		},
	];

	// La lezione si apre con la pagina della struttura, come la vede lei, in sola lettura (vistaStruttura.js)
	function openDetail(row) {
		const attivaOAnnullata = row.status === 'PURCHASABLE' || row.status === 'CANCELLED';
		const percorso = attivaOAnnullata ? '/struttura/booking/lessonsview/' : '/struttura/booking/lessonseditmultiple/';
		apriComeLaStruttura(navigate, { clubId: row.clubId, nome: row.clubName, percorso: percorso + row.id });
	}

	useEffect(() => {
		const fetchData = async () => {
			try {
				const tokenDetailsString = sessionStorage.getItem('userDetails');
				if (tokenDetailsString) {
					const tokenDetails = JSON.parse(tokenDetailsString);
					let token = tokenDetails.idToken;
					const apiClient = new MyApiClient();

					setLoadingShowed(true);
					const [bookingLessons] = await Promise.all([
						apiClient.getBookingLessons(token)
					]);
					setLoadingShowed(false);

					if(bookingLessons) {
						let data = [];
						bookingLessons.forEach(element => {

							let status = null;
							if(element.status === 'DRAFT') {
								status = {
									"label": "Bozza",
									"class": "text-secondary"
								};
							} else if(element.status === 'PURCHASABLE') {
								status = {
									"label": "Attivo",
									"class": "text-success"
								};
							} else if(element.status === 'CANCELLED') {
								status = {
									"label": "Non attivo",
									"class": "text-warning"
								};
							}

							let imageClub = null;
                            if(element.clubPicture) {
								imageClub = element.clubPicture.uri;
							}

							let row = {
								"id": element.id,
								"name": element.name,
								"clubName": element.clubName || 'N/A',
								"clubId": element.clubId,
								"imageUrlClub": imageClub,
								"sportType": nomiSport(element),
								"standard_price": "€ "+(element.standard_price).toFixed(2),
								"status": element.status,
								"status_label": element.archived ? STATO_ARCHIVIATO : status,
								"archivio": !!element.archived,
								"purchasesCount": element.purchasesCount,
							};
							data.push(row);
							
						});
						setDataJson(data);
					}
				}
			} catch (error) {
				console.error("Error fetching data:", error);
			}
		};

		fetchData();

	}, []);

	return (
		<>
			<Modal className="fade" show={loadingShowed} centered>
				<Modal.Body className="text-center">
				<Spinner animation="border" role="status">
					<span className="sr-only">Loading...</span>
				</Spinner>
				<div>Caricamento in corso...</div>
				</Modal.Body>
			</Modal>

			<Modal className="fade" show={modalShowed} centered>
				<Modal.Header>
					<Modal.Title>{modalTitle}</Modal.Title>
					<Button onClick={() => setModalShowed(false)} variant="" className="btn-close">
					</Button>
				</Modal.Header>
				<Modal.Body>
					<Row><Col className="col-xl-64">{modalText}</Col></Row>
				</Modal.Body>
				<Modal.Footer className="justify-content-between">
					<Button className="btn btn-primary btn-add" onClick={() => setModalShowed(false)}>
						Chiudi
					</Button>
				</Modal.Footer>
			</Modal>

			<TabellaLista
				pageList={true}
				cardTitle={'Lezioni'}
				hasSearch={true}
				searchPlaceholder={'Cerca per struttura, nome o sport'}
				hasFilter={false}
				filterControl={
					<div className="sid-chip-filters">
						<ChipFilter label="Stato" options={STATO_OPTIONS} value={statoFilter} onChange={setStatoFilter} multiple />
						<SelettoreArchivio value={vista} onChange={setVista} />
					</div>
				}
				data_column={data_column}
				openColumn={'name'}
				openRow={(row) => openDetail(row)}
				data_json={filteredData}
				hasAddMore={false}
				sort_by={'name'}
				sort_type={'asc'}
			/>
		</>
	)
};

export default AdminLessonsTable;